<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="城市名称">
          <el-input
            v-model="query.cityName"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增城市</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="cityCode" label="城市编码"></el-table-column>
        <el-table-column prop="cityName" label="城市名称"></el-table-column>
        <el-table-column prop="provinceName" label="所属省份"></el-table-column>
        <el-table-column prop="sortOrder" label="排序"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{ row }">
            <el-tag
              :type="row.enabled === 1 ? 'success' : 'info'"
              size="small"
              >{{ row.enabled === 1 ? "启用" : "禁用" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button
              type="text"
              style="color: #f56c6c"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑城市' : '新增城市'"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="城市编码" prop="cityCode">
          <el-input v-model="form.cityCode" placeholder="如 320100"></el-input>
        </el-form-item>
        <el-form-item label="城市名称" prop="cityName">
          <el-input v-model="form.cityName"></el-input>
        </el-form-item>
        <el-form-item label="省份编码" prop="provinceCode">
          <el-input
            v-model="form.provinceCode"
            placeholder="如 320000"
          ></el-input>
        </el-form-item>
        <el-form-item label="省份名称" prop="provinceName">
          <el-input v-model="form.provinceName"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="form.enabled"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </el-form-item>
        <el-form-item label="热门">
          <el-switch
            v-model="form.hotFlag"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </el-form-item>
        <el-form-item label="默认城市">
          <el-switch
            v-model="form.defaultFlag"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCities, addCity, updateCity, deleteCity } from "../../api";

export default {
  name: "CityManage",
  data() {
    return {
      query: { cityName: "" },
      rawList: [],
      list: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        cityCode: "",
        cityName: "",
        provinceCode: "",
        provinceName: "",
        sortOrder: 0,
        enabled: 1,
        hotFlag: 0,
        defaultFlag: 0,
      },
      rules: {
        cityCode: [
          { required: true, message: "请输入城市编码", trigger: "blur" },
        ],
        cityName: [
          { required: true, message: "请输入城市名称", trigger: "blur" },
        ],
        provinceCode: [
          { required: true, message: "请输入省份编码", trigger: "blur" },
        ],
        provinceName: [
          { required: true, message: "请输入省份名称", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;
      getCities()
        .then((res) => {
          this.rawList = res.data.records || res.data || [];
          this.applyFilter();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.applyFilter();
    },
    reset() {
      this.query = { cityName: "" };
      this.applyFilter();
    },
    applyFilter() {
      const keyword = String(this.query.cityName || "").trim().toLowerCase();
      if (!keyword) {
        this.list = [...this.rawList];
        return;
      }
      this.list = (this.rawList || []).filter((item) => {
        return String(item.cityName || "").toLowerCase().includes(keyword) ||
          String(item.cityCode || "").toLowerCase().includes(keyword) ||
          String(item.provinceName || "").toLowerCase().includes(keyword);
      });
    },
    handleAdd() {
      this.isEdit = false;
      this.form = {
        id: null,
        cityCode: "",
        cityName: "",
        provinceCode: "",
        provinceName: "",
        sortOrder: 0,
        enabled: 1,
        hotFlag: 0,
        defaultFlag: 0,
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.form = { ...row };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const fn = this.isEdit
          ? updateCity(this.form.id, this.form)
          : addCity(this.form);
        fn.then(() => {
          this.$message.success(this.isEdit ? "修改成功" : "新增成功");
          this.dialogVisible = false;
          this.fetchList();
        });
      });
    },
    handleDelete(row) {
      this.$confirm("确定要删除该城市吗？", "提示", { type: "warning" })
        .then(() => {
          deleteCity(row.id).then(() => {
            this.$message.success("删除成功");
            this.fetchList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
